import { push } from 'connected-react-router';
import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getApplications(body) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_APPLICATIONS_REQUEST,
			payload: {
				loading: true
			}
		});

		const response = await API.booking.getApplications({ search: JSON.stringify(body) });

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_APPLICATIONS_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
		}

		dispatch({
			type: ActionTypes.GET_APPLICATIONS_ERROR,
			payload: {
				applications: response.data.applications,
				loading: false
			}
		});
	};
}
export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_APPLICATIONS_META
		});
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_APPLICATIONS_PAGE
		});
	};
}
